import { render, staticRenderFns } from "./VenueBooking.vue?vue&type=template&id=2410c812&scoped=true"
import script from "./VenueBooking.vue?vue&type=script&lang=js"
export * from "./VenueBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410c812",
  null
  
)

export default component.exports